import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography, IconButton } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

interface DosenEllipsisMenuProps {
  onViewProfile?: () => void;
  onCancelMatch?: () => void;
}

export default function DosenEllipsisMenu({ onViewProfile, onCancelMatch }: DosenEllipsisMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          color: 'var(--Text-text-primary, #FFF)',
          padding: '4px'
        }}
      >
        <MoreHorizIcon sx={{ fontSize: 20 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        PaperProps={{
          sx: {
            px: '14px', // 3.5
            py: '10px', // 2.5
            background: 'var(--Fill-background, #1C1C1C)',
            borderRadius: '5px',
            // outline: '1px solid var(--Stroke-Border-border, rgba(255,255,255,0.25))',
            outlineOffset: '-1px',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px', // ~1.5
            boxShadow: 'none',
            minWidth: '180px'
          }
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {/* ITEM 1 — DEFAULT */}
        <MenuItem
          onClick={() => {
            handleClose();
            onViewProfile?.();
          }}
          sx={{
            py: '6px',
            px: '0px',
            borderRadius: '6px',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            minHeight: 'unset !important',

            '&:hover': {
              background: 'rgba(255,255,255,0.07)'
            }
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--Text-text-primary, #FFF)'
            }}
          >
            View Mentee Profile
          </Typography>
        </MenuItem>

        {/* ITEM 2 — RED */}
        <MenuItem
          onClick={() => {
            handleClose();
            onCancelMatch?.();
          }}
          sx={{
            py: '6px',
            px: '0px',
            borderRadius: '6px',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            minHeight: 'unset !important',

            '&:hover': {
              background: 'rgba(255, 0, 0, 0.10)'
            }
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--UI-Error, #FF4D4D)'
            }}
          >
            Cancel Match
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
